/**
 * 公用数据存放
 *
 */
const publicData = {
  state:{
      domainUrl:'/',
      //文件上传(无凭证访问) POST
      uploadUrl:'/jbbcs/file/uploadOpenImg.do',

      //文件访问(无凭证访问) GET
      showFile:'/showFile/',

      //文件上传(访问图片时需带凭证 token) POST
      uploadUrlToken:'/jbbcs/file/uploadImg.do',

      //文件访问(需带凭证访问) GET
      showFileToken:'/jbbcs/file/getUploadFile/',

      skuArray:[
        {
          label:'公司',
          value:'GSJY',
          check:false,
        },
        {
          label:'网店',
          value:'WD',
          check:false,
        },
        {
          label:'新媒体',
          value:'XMT',
          check:false,
        },{
          label:'著作权',
          value:'BQ',
          check:false,
        },
        {
          label:'商标',
          value:'SB',
          check:false,
        },{
          label:'网站',
          value:'WZ',
          check:false,
        },{
          label:'专利',
          value:'ZL',
          check:false,
        }
    ],

    skuArrayAll:[
        {
            label:'全部',
            value:'',
            check:false,
          },
        {
          label:'公司',
          value:'GSJY',
          check:false,
        },
        {
          label:'网店',
          value:'WD',
          check:false,
        },
        {
          label:'新媒体',
          value:'XMT',
          check:false,
        },{
          label:'著作权',
          value:'BQ',
          check:false,
        },
        {
          label:'商标',
          value:'SB',
          check:false,
        },{
          label:'网站',
          value:'WZ',
          check:false,
        },{
          label:'专利',
          value:'ZL',
          check:false,
        }
    ],



        //著作权类型和题材
      themeData: [
        // 题材
        {
          bigId: 1,
          name: "小说",
          children: [
            { childId: 1, val: "青春言情" },
            { childId: 2, val: "古言穿越" },
            { childId: 3, val: "民国演义" },
            { childId: 4, val: "家庭伦理" },
            { childId: 5, val: "历史传奇" },
            { childId: 6, val: "恐怖悬疑" },
            { childId: 7, val: "武侠仙侠" },
            { childId: 8, val: "军事战争" },
            { childId: 9, val: "综合其他" }
          ]
        },
        {
          bigId: 2,
          name: "剧本",
          children: [
            { childId: 1, val: "电影剧本" },
            { childId: 2, val: "电视剧剧本" },
            { childId: 3, val: "动画剧本" },
            { childId: 4, val: "微电影剧本" },
            { childId: 5, val: "话剧剧本" },
            { childId: 6, val: "微动漫剧本" },
            { childId: 7, val: "小说剧本" },
            { childId: 8, val: "相声剧本" },
            { childId: 9, val: "小品剧本" }
          ]
        },
        {
          bigId: 3,
          name: "人文社科",
          children: [
            { childId: 1, val: "经济管理" },
            { childId: 2, val: "励志成功" },
            { childId: 3, val: "政治军事" },
            { childId: 4, val: "自然风情" },
            { childId: 5, val: "旅游探险" },
            { childId: 6, val: "科技文化" },
            { childId: 7, val: "社会民俗" },
            { childId: 8, val: "异域风情" }
          ]
        },
        {
          bigId: 4,
          name: "美术",
          children: [
            { childId: 1, val: "绘画" },
            { childId: 2, val: "雕刻" },
            { childId: 3, val: "书法" },
            { childId: 4, val: "工艺美术" },
            { childId: 5, val: "建筑艺术" }
          ]
        },
        {
          bigId: 5,
          name: "漫画",
          children: [
            { childId: 1, val: "儿童漫画" },
            { childId: 2, val: "少年漫画" },
            { childId: 3, val: "少女漫画" },
            { childId: 4, val: "青年漫画" },
            { childId: 5, val: "女性漫画" },
            { childId: 6, val: "其它漫画" }
          ]
        },
        {
          bigId: 6,
          name: "摄影",
          children: [
            { childId: 1, val: "风光" },
            { childId: 2, val: "风情" },
            { childId: 3, val: "纪实" },
            { childId: 4, val: "创意" }
          ]
        },
        {
          bigId: 7,
          name: "软件",
          children: [
            { childId: 1, val: "系统软件" },
            { childId: 2, val: "APP" },
            { childId: 3, val: "PC网站" },
            { childId: 4, val: "WAP网站" },
            { childId: 5, val: "应用软件" },
            { childId: 6, val: "游戏娱乐" },
            { childId: 7, val: "微信小程序" },
            { childId: 8, val: "H5" },
            { childId: 9, val: "媒体工具" },
            { childId: 10, val: "插件" }
          ]
        },
        {
          bigId: 8,
          name: "图形",
          children: [
            { childId: 1, val: "工程设计" },
            { childId: 2, val: "产品设计图纸" },
            { childId: 3, val: "地图" },
            { childId: 4, val: "示意图" }
          ]
        },
        {
          bigId: 9,
          name: "电影",
          children: [
            { childId: 1, val: "剧情" },
            { childId: 2, val: "文艺" },
            { childId: 3, val: "喜剧" },
            { childId: 4, val: "爱情" },
            { childId: 5, val: "犯罪" },
            { childId: 6, val: "战争" },
            { childId: 7, val: "恐怖" },
            { childId: 8, val: "动画" },
            { childId: 9, val: "灾难" },
            { childId: 10, val: "动作" },
            { childId: 11, val: "冒险" },
            { childId: 12, val: "悬疑" },
            { childId: 13, val: "历史" },
            { childId: 14, val: "搞笑" },
            { childId: 15, val: "都市" },
            { childId: 16, val: "警匪" },
            { childId: 17, val: "传记" },
            { childId: 18, val: "儿童" },
            { childId: 19, val: "武侠" },
            { childId: 20, val: "科幻" },
            { childId: 21, val: "纪录片" },
            { childId: 22, val: "西部" },
            { childId: 23, val: "戏曲" },
            { childId: 24, val: "奇幻" },
            { childId: 25, val: "短片" }
          ]
        },
        {
          bigId: 10,
          name: "电视剧",
          children: [
            { childId: 1, val: "神话" },
            { childId: 2, val: "古装" },
            { childId: 3, val: "悬疑" },
            { childId: 4, val: "历史" },
            { childId: 5, val: "偶像" },
            { childId: 6, val: "家庭" },
            { childId: 7, val: "战争" },
            { childId: 8, val: "警匪" },
            { childId: 9, val: "喜剧" },
            { childId: 10, val: "传记" },
            { childId: 11, val: "生活" },
            { childId: 12, val: "剧情" },
            { childId: 13, val: "武侠" },
            { childId: 14, val: "科幻" },
            { childId: 15, val: "儿童" },
            { childId: 16, val: "农村" },
            { childId: 17, val: "都市" },
            { childId: 18, val: "搞笑" },
            { childId: 19, val: "爱情" },
            { childId: 20, val: "时装" },
            { childId: 21, val: "谍战" },
            { childId: 22, val: "职场" },
            { childId: 23, val: "年代" }
          ]
        },
        {
          bigId: 11,
          name: "动画片",
          children: [
            { childId: 1, val: "少年" },
            { childId: 2, val: "经典" },
            { childId: 3, val: "萌系" },
            { childId: 4, val: "搞笑" },
            { childId: 5, val: "少女" },
            { childId: 6, val: "魔幻" },
            { childId: 7, val: "科幻" },
            { childId: 8, val: "推理" },
            { childId: 9, val: "真人" },
            { childId: 10, val: "连载" },
            { childId: 11, val: "儿童益智" },
            { childId: 12, val: "儿童教育" },
            { childId: 13, val: "儿童历险" },
            { childId: 14, val: "儿童奇幻" },
            { childId: 15, val: "儿童搞笑" },
            { childId: 16, val: "儿童竞技" }
          ]
        },
        {
          bigId: 12,
          name: "栏目",
          children: [
            { childId: 1, val: "综艺" },
            { childId: 2, val: "健康" },
            { childId: 3, val: "军事" },
            { childId: 4, val: "情感" },
            { childId: 5, val: "家庭" },
            { childId: 6, val: "时尚" },
            { childId: 7, val: "旅游" },
            { childId: 8, val: "法制" }
          ]
        },
        {
          bigId: 13,
          name: "人才类",
          children: [
            { childId: 1, val: "人物" },
            { childId: 2, val: "军事" },
            { childId: 3, val: "历史" },
            { childId: 4, val: "天文" },
            { childId: 5, val: "自然" },
            { childId: 6, val: "考古" },
            { childId: 7, val: "探险" },
            { childId: 8, val: "科技" },
            { childId: 9, val: "文化" },
            { childId: 10, val: "社会" },
            { childId: 11, val: "刑侦" },
            { childId: 12, val: "旅游" },
            { childId: 13, val: "动物" },
            { childId: 14, val: "地理" },
            { childId: 15, val: "金融" },
            { childId: 16, val: "艺术" },
            { childId: 14, val: "建筑" },
            { childId: 15, val: "美食" },
            { childId: 16, val: "百科" }
          ]
        },
        {
          bigId: 14,
          name: "其他视频",
          children: [
            { childId: 1, val: "网剧" },
            { childId: 2, val: "短视频" }
          ]
        },
        {
          bigId: 15,
          name: "音乐",
          children: [
            { childId: 1, val: "音乐" },
            { childId: 2, val: "MV" },
            { childId: 3, val: "演唱会" },
            { childId: 4, val: "其它" }
          ]
        },
        {
          bigId: 16,
          name: "游戏",
          children: [
            { childId: 1, val: "客户端游戏" },
            { childId: 2, val: "手机游戏" },
            { childId: 3, val: "网页游戏" },
            { childId: 4, val: "VR游戏" },
            { childId: 5, val: "H5游戏" },
            { childId: 6, val: "角色扮演" },
            { childId: 7, val: "射击游戏" },
            { childId: 8, val: "动作类游戏" },
            { childId: 9, val: "冒险类游戏" },
            { childId: 10, val: "战略角色扮演" },
            { childId: 11, val: "模拟经营" },
            { childId: 12, val: "赛车类" },
            { childId: 13, val: "运动类" },
            { childId: 14, val: "格斗类" },
            { childId: 15, val: "音乐类" },
            { childId: 16, val: "益智类" },
            { childId: 14, val: "互动娱乐" },
            { childId: 15, val: "策略" }
          ]
        },
        {
          bigId: 17,
          name: "其他",
          children: [{ childId: 1, val: "其它" }]
        }
      ],

        // 新媒体账号类型
        accountType:[
            {name:'帅哥',value:'帅哥'},
            {name:'美女',value:'美女'},
            {name:'搞笑',value:'搞笑'},
            {name:'音乐',value:'音乐'},
            {name:'段子',value:'段子'},
            {name:'舞蹈',value:'舞蹈'},
            {name:'时尚',value:'时尚'},
            {name:'萌娃',value:'萌娃'},
            {name:'宠物',value:'宠物'},
            {name:'美食',value:'美食'},
            {name:'游戏',value:'游戏'},
            {name:'创意',value:'创意'},
            {name:'美妆',value:'美妆'},
            {name:'母婴',value:'母婴'},
            {name:'汽车',value:'汽车'},
            {name:'生活',value:'生活'},
            {name:'体育',value:'体育'},
            {name:'健身',value:'健身'},
            {name:'科技',value:'科技'},
            {name:'教育',value:'教育'},
            {name:'应是',value:'应是'},
            {name:'文字',value:'文字'},
            {name:'情感',value:'情感'},
            {name:'旅行',value:'旅行'},
            {name:'摄影',value:'摄影'},
            {name:'美图',value:'美图'},
            {name:'明星',value:'明星'},
            {name:'动漫',value:'动漫'},
            {name:'穿搭',value:'穿搭'},
            {name:'其它',value:'其它'},
            {name:'本地',value:'本地'},
            {name:'两性',value:'两性'},
            {name:'星座',value:'星座'},
            {name:'职场',value:'职场'},
            {name:'种草',value:'种草'},
            {name:'技巧',value:'技巧'},
            {name:'户外',value:'户外'},
            {name:'励志',value:'励志'},
            {name:'测评',value:'测评'},
            {name:'减肥',value:'减肥'},
            {name:'书单',value:'书单'},
            {name:'玩具',value:'玩具'},
            {name:'故事',value:'故事'},
        ],





        wdDpType: [
            {value: '1', label: "家用电器"},
            {value: '2', label: "手机"},
            {value: '3', label: "运营商"},
            {value: '4', label: "数码"},
            {value: '5', label: "电脑"},
            {value: '6', label: "办公"},
            {value: '7', label: "家居"},
            {value: '8', label: "家具"},
            {value: '9', label: "家装"},
            {value: '10', label: "厨具"},
            {value: '11', label: "男装"},
            {value: '12', label: "女装"},
            {value: '13', label: "童装"},
            {value: '14', label: "内衣"},
            {value: '15', label: "美妆"},
            {value: '16', label: "个护清洁"},
            {value: '17', label: "宠物"},
            {value: '19', label: "箱包"},
            {value: '20', label: "钟表"},
            {value: '21', label: "珠宝"},

            // value的顺序错乱的，不要按顺序改
            {value: '22', label: "男鞋"},
            {value: '18', label: "女鞋"},
            {value: '56', label: "童鞋"},


            {value: '23', label: "运动"},
            {value: '24', label: "户外"},
            {value: '25', label: "房产"},
            {value: '26', label: "汽车"},
            {value: '27', label: "汽车用品"},
            {value: '28', label: "母婴"},
            {value: '29', label: "玩具乐器"},
            {value: '30', label: "食品"},
            {value: '31', label: "酒类"},
            {value: '32', label: "生鲜"},
            {value: '33', label: "特产"},
            {value: '34', label: "艺术"},
            {value: '35', label: "礼品鲜花"},
            {value: '36', label: "农资绿植"},
            {value: '37', label: "医药保健"},
            {value: '38', label: "计生情趣"},
            {value: '39', label: "图书"},
            {value: '40', label: "文娱"},
            {value: '41', label: "教育"},
            {value: '42', label: "电子书"},
            {value: '43', label: "机票"},
            {value: '44', label: "酒店"},
            {value: '45', label: "旅游"},
            {value: '46', label: "生活"},
            {value: '47', label: "理财"},
            {value: '48', label: "众筹"},
            {value: '49', label: "白条"},
            {value: '50', label: "保险"},
            {value: '51', label: "安装"},
            {value: '52', label: "维修"},
            {value: '53', label: "清洗"},
            {value: '54', label: "二手"},
            {value: '55', label: "工业品"}
            // 56是童鞋,在上面
          ],


       //媒体类型
       mediaTypeData:[
                {name:'抖音',value:'0',type:1},
                {name:'快手',value:'1',type:1},
                {name:'微博',value:'2',type:1},
                {name:'百家号',value:'3',type:1},
                {name:'微信公众号',value:'4',type:1},
                {name:'今日头条',value:'5',type:1},
                {name:'其他',value:'6',type:1},
                {name:'虎牙',value:'7',type:1},
                {name:'斗鱼',value:'8',type:1},
                {name:'哔哩哔哩',value:'9',type:1},
                {name:'小红书',value:'10',type:1},
      ],

      //行业类别
      industryData:[
        { value: "0",label: "不限" },
        { value: "1",label: "农林牧业" },
        { value: "2",label: "食品饮料" },
        { value: "3",label: "家具用品" },
        { value: "4",label: "教育休闲" },
        { value: "5",label: " 医药与医疗" },
        { value: "6",label: "化学化工" },
        { value: "7",label: "电气自动化" },
        { value: "8",label: "新能源" },
        { value: "9",label: "电子信息源" },
        { value: "10",label: "仪器仪表" },
        { value: "11",label: "环保和资源" },
        { value: "12",label: "轻工纺织" },
        { value: "13",label: "包装印刷" },
        { value: "14",label: "建筑建材" },
        { value: "15",label: "新型材料" },
        { value: "16",label: "海洋开发" },
        { value: "17",label: "航空航天" },
        { value: "18",label: " 采矿冶金" },
        { value: "19",label: " 交通运输" },
        { value: "20",label: " 橡胶塑料" },
        { value: "21",label: " 机械" },
        { value: "22",label: " 安全防护" },
        { value: "23",label: " 其他" },
      ],

      //企查查行业分类
      sbHtType: [
          '不限',
          "01-化学原料",
          "02-颜料油漆",
          "03-日化用品",
          "04-燃料油脂",
          "05-医药用品",
          "06-金属材料",
          "07-机械设备",
          "08-手工器械",
          "09-科学仪器",
          "10-医疗器械",
          "11-灯具空调",
          "12-运输工具",
          "13-烟火相关",
          "14-珠宝钟表",
          "15-乐器",
          "16-办公用品",
          "17-橡胶制品",
          "18-皮革皮具",
          "19-建筑材料",
          "20-家具用品",
          "21-厨房洁具",
          "22-绳网袋蓬",
          "23-纱线丝",
          "24-布料床单",
          "25-服装鞋帽",
          "26-钮扣拉链",
          "27-地毯席垫",
          "28-健身器材",
          "29-食品",
          "30-方便食品",
          "31-饲料种籽",
          "32-啤酒饮料",
          "33-酒精饮品",
          "34-烟草烟具",
          "35-广告销售",
          "36-金融物管",
          "37-建筑修理",
          "38-通讯服务",
          "39-运输贮藏",
          "40-材料加工",
          "41-教育娱乐",
          "42-网站服务",
          "43-餐饮住宿",
          "44-医疗园艺",
          "45-社会服务",
      ],


      //商标类型
      brandTypeData:[
        {label:'中文',value:'0',},
        {label:'英文',value:'1',},
        {label:'中文+英文',value:'2',},
        {label:'图形',value:'3',},
        {label:'中文+图形',value:'4',},
        {label:'组合',value:'5',},
        {label:'数字',value:'6',},
        {label:'拼音',value:'7',},
        {label:'英文+图形',value:'8',},
        {label:'中文+拼音',value:'9',},
        {label:'中文+英文+图形',value:'10',}
      ],
      //网店商城类型
      mallType: [
        { label: "旗舰店", value: "1" },
        { label: "专营店", value: "2" },
        { label: "专卖店", value: "3" },
        { label: "优创店", value: "4" },
        { label: "全球购", value: "5" },
        { label: "自营", value: "6" },
        { label: "拼购", value: "7" },
      ],
      // 网店商标类型
      wdtmType:[
        {
            value: "1",
            label: "R标",
        },
        {
            value: "2",
            label: "TM标",
        },
        {
            value: "3",
            label: "授权商标",
        },
        {
            value: "4",
            label: "自有商标",
        },
        {
            value: "5",
            label: "可贴牌",
        },
      ],
      //平台类型
      platTypeData:[
        { value: "1",label: "京东" },
          { value: "2",label: "天猫" },
          { value: "3",label: "淘宝" },
          { value: "4",label: "蘑菇街" },
          // { value: "5",label: "亚马逊" },
          { value: "6",label: "小红书" },
           { value: "7",label: "1688" },
          { value: "8",label: "拼多多" },
        //   { value: "9",label: "京东" },
          // { value: "30",label: "其他" },
    ],
      //专利类型
      patentType:[
            { value: "0",label: "发明授权" },
            { value: "1",label: "实用新型" },
            { value: "2",label: "外观设计" },
            { value: "3",label: "发明公布" },
        ],


      //网站类型
      webTypeData:[
          { value: "1",label: "垂直行业" },
          { value: "2",label: "游戏" },
          { value: "3",label: "软件下载" },
          { value: "4",label: "电影视频" },
          { value: "5",label: " 小说" },
          { value: "6",label: "音乐DJ" },
          { value: "7",label: "地方门户" },
          { value: "8",label: "动漫" },
          { value: "9",label: "女性时尚" },
          { value: "10",label: "新闻娱乐" },
          { value: "11",label: "母婴亲子" },
          { value: "12",label: "教育培训" },
          { value: "13",label: "金融财经" },
          { value: "14",label: "体育直播" },
          { value: "15",label: "星座命理" },
          { value: "16",label: "美食菜谱" },
          { value: "17",label: "健康养生" },
      ],

      //系统类型
      sysTypeData:[
        { value: "1",label: "Dede织梦" },
        { value: "2",label: "帝国Cms" },
        { value: "3",label: "蚂蚁Cms" },
        { value: "4",label: "Zblog" },
        { value: "5",label: " 杰奇" },
        { value: "6",label: "苹果Cms" },
        { value: "7",label: "Discuz" },
        { value: "8",label: "WordPress" },
        { value: "9",label: "PHP" },
        { value: "10",label: "ASP" },
        { value: "11",label: ".NET" },
        { value: "12",label: "JAVA" },
        { value: "13",label: "自研程序" },
        { value: "14",label: "其他" },
    ],

    //百度权重
    weightData:[
      { value: "1",label: "BDR0" },
      { value: "2",label: "BDR1" },
      { value: "3",label: "BDR2" },
      { value: "4",label: "BDR3" },
      { value: "5",label: " BDR4" },
      { value: "6",label: "BDR5" },
      { value: "7",label: "BDR6" },
      { value: "8",label: "BDR7+" },
    ],

    //PR值
    prData:[
        { value: "0",label: "0" },
        { value: "1",label: "1" },
        { value: "2",label: "2" },
        { value: "3",label: "3" },
        { value: "4",label: " 4" },
        { value: "5",label: "5" },
        { value: "6",label: "6" },
      ],
    //IP值
    ipData:[
        { value: "0",label: "≤100" },
        { value: "1",label: "100-500" },
        { value: "2",label: "500-1000" },
        { value: "3",label: "1000-5000" },
        { value: "4",label: "≥5000" },
      ],

     //企业类型
     companyTypeData:[
      { value: "0",label: "全部" },
      { value: "1",label: "有限责任公司" },
      { value: "2",label: "股份公司" },
      { value: "3",label: "集团公司" },
      { value: "4",label: "有限合伙企业" },
      { value: "5",label: " 普通合伙企业" },
      { value: "6",label: "个人独资企业" },
    ],

    //授权范围
    authRanges:[
        { value: "1",label: "复制权" },
        { value: "2",label: "发行权" },
        { value: "3",label: "出租权" },
        { value: "4",label: " 展览权" },
        { value: "5",label: "表演权" },
        { value: "6",label: "放映权" },
        { value: "7",label: "广播权" },
        { value: "8",label: "信息网络传播权" },
        { value: "9",label: "摄制权" },
        { value: "10",label: "改编权" },
        { value: "11",label: "翻译权" },
        { value: "12",label: "汇编权" },
        { value: "13",label: "其他权" },
    ],



     // 企业分类
     industryClassify:[
        {bigId: 1,name: "商贸贸易"},
        {bigId: 2,name: "电子商务"},
        {bigId: 3,name: "科技信息"},
        {bigId: 4,name: "金融投资"},
        {bigId: 5,name: "广告传媒"},
        {bigId: 6,name: "家居建材"},
        {bigId: 7,name: "咨询服务"},
        {bigId: 8,name: "食品农业"},
        {bigId: 9,name: "会务展览"},
        {bigId: 10,name: "物流供应链"},
        {bigId: 11,name: "教育培训"},
        {bigId: 12,name: "餐饮美容"},
        {bigId: 13,name: "印刷包装"},
        {bigId: 14,name: "珠宝服饰"},
        {bigId: 15,name: "实业生产"},
        {bigId: 16,name: "通讯网络"},
        {bigId: 17,name: "建筑装饰"},
        {bigId: 18,name: "经纪中介"},
        {bigId: 19,name: "物业地产"},
        {bigId: 20,name: "设计咨询"},
        {bigId: 21,name: "其他行业"},
      ],

      incidentallys: [
        {
            "name": "无",
            "type": "2",
            "value": "100"
        },
        {
            "name": "网站网店",
            "type": "1",
            "value": "0"
        },
        {
            "name": "商标专利",
            "type": "1",
            "value": "1"
        },
        {
            "name": "资质批文",
            "type": "1",
            "value": "2"
        },
        {
            "name": "带车牌",
            "type": "1",
            "value": "3"
        },
        {
            "name": "渠道资源",
            "type": "1",
            "value": "4"
        },
        {
            "name": "限制性行业",
            "type": "1",
            "value": "5"
        },
        {
            "name": "带商标",
            "type": "1",
            "value": "6"
        },
        {
            "name": "带资质",
            "type": "1",
            "value": "7"
        },
        {
            "name": "其他",
            "type": "1",
            "value": "8"
        },
        {
            "name": "专利",
            "type": "1",
            "value": "9"
        },
        {
            "name": "版权",
            "type": "1",
            "value": "10"
        },
        {
            "name": "软著",
            "type": "1",
            "value": "11"
        },
        {
            "name": "食品经营许可证",
            "type": "1",
            "value": "12"
        },
        {
            "name": "食品生产许可证",
            "type": "1",
            "value": "13"
        },
        {
            "name": "食品流通许可证",
            "type": "1",
            "value": "14"
        },
        {
            "name": "EDI（在线数据处理与交易处理业务）",
            "type": "1",
            "value": "15"
        },
        {
            "name": "ISP（互联网接入业务）",
            "type": "1",
            "value": "16"
        },
        {
            "name": "CDN（内容分发网络业务）",
            "type": "1",
            "value": "17"
        },
        {
            "name": "IP-VPN（国内互联网虚拟专用网业务）",
            "type": "1",
            "value": "18"
        },
        {
            "name": "网络文化经营许可证（文网文）",
            "type": "1",
            "value": "19"
        },
        {
            "name": "医疗器械生产许可证",
            "type": "1",
            "value": "20"
        },
        {
            "name": "一类医疗器械经营许可证",
            "type": "1",
            "value": "21"
        },
        {
            "name": "二类疗器械经营许可证",
            "type": "1",
            "value": "22"
        },
        {
            "name": "三类医疗器械经营许可证",
            "type": "1",
            "value": "23"
        },
        {
            "name": "互联网药品交易服务资格证书",
            "type": "1",
            "value": "24"
        },
        {
            "name": "医药经营许可证（零售）",
            "type": "1",
            "value": "25"
        },
        {
            "name": "药品生产许可证",
            "type": "1",
            "value": "26"
        },
        {
            "name": "医药经营许可证（批发）",
            "type": "1",
            "value": "27"
        },
        {
            "name": "旅行社业务经营许可证（国内）",
            "type": "1",
            "value": "28"
        },
        {
            "name": "旅行社业务经营许可证（国外）",
            "type": "1",
            "value": "29"
        },
        {
            "name": "人力资源服务许可证",
            "type": "1",
            "value": "30"
        },
        {
            "name": "劳务派遣许可证",
            "type": "1",
            "value": "31"
        },
        {
            "name": "快递业务经营许可证",
            "type": "1",
            "value": "32"
        },
        {
            "name": "道路运输经营许可证",
            "type": "1",
            "value": "33"
        },
        {
            "name": "危险化学品经营许可证",
            "type": "1",
            "value": "34"
        },
        {
            "name": "危险化学品运输许可证",
            "type": "1",
            "value": "35"
        },
        {
            "name": "动画片发行许可证",
            "type": "1",
            "value": "36"
        },
        {
            "name": "广播电视节目制作经营许可证",
            "type": "1",
            "value": "37"
        },
        {
            "name": "信息网络传播视听节目许可证",
            "type": "1",
            "value": "38"
        },
        {
            "name": "电影发行经营许可证",
            "type": "1",
            "value": "39"
        },
        {
            "name": "电视剧发行许可证",
            "type": "1",
            "value": "40"
        },
        {
            "name": "游戏版号",
            "type": "1",
            "value": "41"
        },
        {
            "name": "物业管理资质",
            "type": "1",
            "value": "42"
        },
        {
            "name": "安保资质",
            "type": "1",
            "value": "43"
        },
        {
            "name": "高新技术企业（国高）",
            "type": "1",
            "value": "44"
        },
        {
            "name": "高新技术企业（市高）",
            "type": "1",
            "value": "45"
        },
        {
            "name": "融资租赁许可证",
            "type": "1",
            "value": "46"
        },
        {
            "name": "私募备案",
            "type": "1",
            "value": "47"
        },
        {
            "name": "金融许可证",
            "type": "1",
            "value": "48"
        },
        {
            "name": "保险从业资格证",
            "type": "1",
            "value": "49"
        },
        {
            "name": "经营保险经纪业务许可证（带网销）",
            "type": "1",
            "value": "50"
        },
        {
            "name": "保险中介许可证",
            "type": "1",
            "value": "51"
        },
        {
            "name": "ICP（信息服务业务）",
            "type": "1",
            "value": "52"
        },
        {
            "name": "排污许可证",
            "type": "1",
            "value": "53"
        },
        {
            "name": "环评资质甲级",
            "type": "1",
            "value": "54"
        },
        {
            "name": "环评资质乙级",
            "type": "1",
            "value": "55"
        },
        {
            "name": "有害生物防制服务企业资格证书",
            "type": "1",
            "value": "56"
        },
        {
            "name": "进出口许可证",
            "type": "1",
            "value": "57"
        },
        {
            "name": "二类退税",
            "type": "1",
            "value": "58"
        },
        {
            "name": "APP",
            "type": "1",
            "value": "59"
        },
        {
            "name": "办学许可证",
            "type": "1",
            "value": "60"
        },
        {
            "name": "出版物经营许可证",
            "type": "1",
            "value": "61"
        },
        {
            "name": "种子生产经营许可证",
            "type": "1",
            "value": "62"
        },
        {
            "name": "拍卖经营许可证",
            "type": "1",
            "value": "63"
        },
        {
            "name": "保险专业中介许可证",
            "type": "1",
            "value": "64"
        }
    ],


      // 企业类型：
      companyType:[
        {value: 1,label: "有限责任公司"},
        {value: 2,label: "个人独资公司"},
        {value: 3,label: "港澳台公司"},
        {value: 4,label: "集团公司"},
      ],


    // 所属行业类别的两级数据
    industryListVal:[
      {
          bigId:1,
          name:'贸易类',
          children:[
              {
                  childId:1,
                  val:'贸易',
              },
              {
                  childId:2,
                  val:'经贸发展',
              },
              {
                  childId:3,
                  val:'工贸',
              },
              {
                  childId:4,
                  val:'国际贸易',
              },
              {
                  childId:5,
                  val:'商贸',
              },
              {
                  childId:6,
                  val:'电子商务',
              },
          ]
      },
      {
          bigId:2,
          name:'工程类',
          children:[
              {
                  childId:1,
                  val:'建筑装饰工程',
              },
              {
                  childId:2,
                  val:'土石方工程',
              },
              {
                  childId:3,
                  val:'园林绿化工程',
              },
              {
                  childId:4,
                  val:'市政工程',
              },
              {
                  childId:5,
                  val:'钢结构工程',
              },
              {
                  childId:6,
                  val:'环境工程',
              },
              {
                  childId:7,
                  val:'能源工程',
              },
              {
                  childId:8,
                  val:'建设工程',
              },
          ]
      },
      {
          bigId:3,
          name:'材料类',
           children:[
              {
                  childId:1,
                  val:'建材',
              },
              {
                  childId:2,
                  val:'装潢材料',
              },
              {
                  childId:3,
                  val:'新材料',
              },
              {
                  childId:4,
                  val:'能源材料',
              },
              {
                  childId:5,
                  val:'符合材料',
              },
              {
                  childId:6,
                  val:'环保材料',
              },
              {
                  childId:7,
                  val:'塑料',
              },
              {
                  childId:8,
                  val:'符合材料',
              },
          ]
      },
      {
          bigId:4,
          name:'设计/企划类',
          children:[
              {
                  childId:1,
                  val:'建筑设计',
              },
              {
                  childId:2,
                  val:'平面设计',
              },
              {
                  childId:3,
                  val:'动漫设计',
              },
              {
                  childId:4,
                  val:'广告',
              },
              {
                  childId:5,
                  val:'文化传播',
              },
              {
                  childId:6,
                  val:'市场营销',
              },
              {
                  childId:7,
                  val:'企业形象策划',
              },
              {
                  childId:8,
                  val:'形象设计',
              },
          ]
      },
      {
          bigId:5,
          name:'服务类',
          children:[
              {
                  childId:1,
                  val:'商务咨询',
              },
              {
                  childId:2,
                  val:'企业管理咨询',
              },
              {
                  childId:3,
                  val:'会务服务',
              },
              {
                  childId:4,
                  val:'翻译服务',
              },
              {
                  childId:5,
                  val:'展览展示服务',
              },
              {
                  childId:6,
                  val:'礼仪服务',
              },
              {
                  childId:7,
                  val:'建筑设计咨询',
              },
              {
                  childId:8,
                  val:'船务',
              },
              {
                  childId:9,
                  val:'教育咨询',
              },
              {
                  childId:10,
                  val:'旅游服务',
              },
              {
                  childId:11,
                  val:'美容美发',
              },
              {
                  childId:12,
                  val:'测试',
              },
              {
                  childId:13,
                  val:'家政服务',
              },
              {
                  childId:14,
                  val:'搬家服务',
              },
              {
                  childId:15,
                  val:'信息咨询',
              },
              {
                  childId:16,
                  val:'汽车服务',
              },
              {
                  childId:17,
                  val:'租赁服务',
              },
              {
                  childId:18,
                  val:'餐饮服务',
              },
              {
                  childId:19,
                  val:'医疗',
              }
          ]
      },
      {
          bigId:6,
          name:'管理类',
          children:[
              {
                  childId:1,
                  val:'企业管理',
              },
              {
                  childId:2,
                  val:'餐饮管理',
              },
              {
                  childId:3,
                  val:'酒店管理',
              },
              {
                  childId:4,
                  val:'物业管理',
              },
              {
                  childId:5,
                  val:'健康管理',
              },
          ]
      },
      {
          bigId:7,
          name:'产品类',
          children:[
              {
                  childId:1,
                  val:'机电',
              },
              {
                  childId:2,
                  val:'电子',
              },
              {
                  childId:3,
                  val:'机械',
              },
              {
                  childId:4,
                  val:'泵阀',
              },
              {
                  childId:5,
                  val:'家具',
              },
              {
                  childId:6,
                  val:'箱包',
              },
              {
                  childId:7,
                  val:'服饰',
              },
              {
                  childId:8,
                  val:'袜业',
              },
              {
                  childId:9,
                  val:'裤业',
              },
              {
                  childId:10,
                  val:'电器',
              },
              {
                  childId:11,
                  val:'实业',
              },
              {
                  childId:12,
                  val:'实业发展',
              },
              {
                  childId:13,
                  val:'木业',
              },
              {
                  childId:14,
                  val:'汽配',
              },
              {
                  childId:15,
                  val:'酒店设备',
              },
              {
                  childId:16,
                  val:'环保设备',
              },
              {
                  childId:17,
                  val:'化妆品',
              },
              {
                  childId:18,
                  val:'工艺品',
              },
              {
                  childId:19,
                  val:'礼品',
              },
              {
                  childId:20,
                  val:'食品',
              },
              {
                  childId:21,
                  val:'家纺',
              },
              {
                  childId:22,
                  val:'珠宝',
              },
              {
                  childId:23,
                  val:'皮具',
              },
              {
                  childId:24,
                  val:'汽车',
              },
              {
                  childId:25,
                  val:'其他',
              },
              {
                  childId:26,
                  val:'劳保用品',
              },
              {
                  childId:27,
                  val:'制造业',
              },
              {
                  childId:28,
                  val:'矿产品',
              },
          ]
      },
      {
          bigId:8,
          name:'科技类',
          children:[
              {
                  childId:1,
                  val:'化工科技',
              },
              {
                  childId:2,
                  val:'能源科技',
              },
              {
                  childId:3,
                  val:'环保科技',
              },
              {
                  childId:4,
                  val:'环境科技',
              },
              {
                  childId:5,
                  val:'生物科技',
              },
              {
                  childId:6,
                  val:'信息科技',
              },
              {
                  childId:7,
                  val:'网络科技',
              },
              {
                  childId:8,
                  val:'数码科技',
              },
              {
                  childId:9,
                  val:'通讯科技',
              },
              {
                  childId:10,
                  val:'动力科技',
              },
              {
                  childId:11,
                  val:'电子科技',
              },
              {
                  childId:12,
                  val:'医药科技',
              },
              {
                  childId:13,
                  val:'教育科技',
              },
              {
                  childId:14,
                  val:'农业科技',
              },
              {
                  childId:15,
                  val:'区块链',
              },
          ]
      },
      {
          bigId:9,
          name:'投资类',
          children:[
              {
                  childId:1,
                  val:'实业投资',
              },
              {
                  childId:2,
                  val:'投资咨询',
              },
              {
                  childId:3,
                  val:'投资控股',
              },
              {
                  childId:4,
                  val:'投资担保',
              },
              {
                  childId:5,
                  val:'创业投资',
              },
              {
                  childId:6,
                  val:'投资管理',
              },
          ]
      },
      {
          bigId:10,
          name:'综合类',
          children:[
              {
                  childId:1,
                  val:'实业',
              },
              {
                  childId:2,
                  val:'企业发展',
              },
              {
                  childId:3,
                  val:'集团',
              },
              {
                  childId:4,
                  val:'股份',
              },
              {
                  childId:5,
                  val:'农业发展',
              }
          ]
      },
      {
          bigId:11,
          name:'物流类',
          children:[
              {
                  childId:1,
                  val:'物流',
              },
              {
                  childId:2,
                  val:'国际物流',
              },
              {
                  childId:3,
                  val:'运输',
              },
              {
                  childId:4,
                  val:'客运',
              },
              {
                  childId:5,
                  val:'仓储第三方物流管理',
              },
              {
                  childId:6,
                  val:'海运',
              },
              {
                  childId:7,
                  val:'航空',
              },
          ]
      },
      {
          bigId:12,
          name:'代理类',
          children:[
              {
                  childId:1,
                  val:'货运代理',
              },
              {
                  childId:2,
                  val:'国际货运代理',
              },
              {
                  childId:3,
                  val:'商标代理',
              },
              {
                  childId:4,
                  val:'专利代理',
              },
              {
                  childId:5,
                  val:'知识产权代理',
              },
              {
                  childId:6,
                  val:'代理报关',
              },
              {
                  childId:7,
                  val:'代理记账',
              },
              {
                  childId:8,
                  val:'代理登记',
              },
              {
                  childId:9,
                  val:'保险代理',
              },
              {
                  childId:10,
                  val:'拍卖代理',
              },
              {
                  childId:11,
                  val:'电子科技',
              },
          ]
      },
      {
          bigId:13,
          name:'人才类',
          children:[
              {
                  childId:1,
                  val:'劳务派遣',
              },
              {
                  childId:2,
                  val:'劳务服务',
              },
              {
                  childId:3,
                  val:'人力资源',
              },
          ]
      },
      {
          bigId:14,
          name:'房产类',
          children:[
              {
                  childId:1,
                  val:'房地产开发',
              },
              {
                  childId:2,
                  val:'置业公司',
              },
              {
                  childId:3,
                  val:'房屋经纪公司',
              },
          ]
      },
      {
          bigId:15,
          name:'金融类',
          children:[
              {
                  childId:1,
                  val:'金融',
              },
              {
                  childId:2,
                  val:'融资租赁',
              },
              {
                  childId:3,
                  val:'商业保理',
              },
              {
                  childId:4,
                  val:'金融服务外包',
              },
              {
                  childId:5,
                  val:'区块链',
              },
          ]
      },
      {
          bigId:16,
          name:'其他',
          children:[
              {
                  childId:1,
                  val:'其他',
              },
              {
                  childId:2,
                  val:'租赁',
              },
          ]
      }
    ],


    //公司性质  出售
    cascaderOptionsSale: [
        {
            value: "0",
            label: "小规模",
        },
        {
            value: "1",
            label: "未核税种",
        },
        {
            value: "2",
            label: "一般纳税人",
        },
    ],

    //公司性质  求购
    cascaderOptionsBuy: [
        {
            value: "10",
            label: "不限",
        },
        {
            value: "0",
            label: "小规模",
        },
        {
            value: "1",
            label: "未核税种",
        },
        {
            value: "2",
            label: "一般纳税人",
        },
    ],


     //银行
     bankData:[
        {
            value:'CDB',
            label:'国家开发银行'
        },
        {
            value:'ICBC',
            label:'中国工商银行'
        },
        {
            value:'ABC',
            label:'中国农业银行'
        },
        {
            value:'BOC',
            label:'中国银行'
        },
        {
            value:'CCB',
            label:'中国建设银行'
        },
        {
            value:'PSBC',
            label:'中国邮政储蓄银行'
        },
        {
            value:'COMM',
            label:'交通银行'
        },
        {
            value:'CMB',
            label:'招商银行'
        },
        {
            value:'SPDB',
            label:'上海浦东发展银行'
        },
        {
            value:'CIB',
            label:'兴业银行'
        },
        {
            value:'HXBANK',
            label:'华夏银行'
        },
        {
            value:'GDB',
            label:'广东发展银行'
        },
        {
            value:'CMBC',
            label:'中国民生银行'
        },
        {
            value:'CITIC',
            label:'中信银行'
        },
        {
            value:'CEB',
            label:'中国光大银行'
        },
        {
            value:'EGBANK',
            label:'恒丰银行'
        },
        {
            value:'CZBANK',
            label:'浙商银行'
        },
        {
            value:'BOHAIB',
            label:'渤海银行'
        },
        {
            value:'SPABANK',
            label:'平安银行'
        },
        {
            value:'SHRCB',
            label:'上海农村商业银行'
        },
        {
            value:'YXCCB',
            label:'玉溪市商业银行'
        },
        {
            value:'YDRCB',
            label:'尧都农商行'
        },
        {
            value:'BJBANK',
            label:'北京银行'
        },
        {
            value:'SHBANK',
            label:'上海银行'
        },
        {
            value:'JSBANK',
            label:'江苏银行'
        },
        {
            value:'HZCB',
            label:'杭州银行'
        },
        {
            value:'NJCB',
            label:'南京银行'
        },
        {
            value:'NBBANK',
            label:'宁波银行'
        },
        {
            value:'HSBANK',
            label:'徽商银行'
        },
        {
            value:'CSCB',
            label:'长沙银行'
        },
        {
            value:'CDCB',
            label:'成都银行'
        },
        {
            value:'CQBANK',
            label:'重庆银行'
        },
        {
            value:'DLB',
            label:'大连银行'
        },
        {
            value:'NCB',
            label:'南昌银行'
        },
        {
            value:'FJHXBC',
            label:'福建海峡银行'
        },
        {
            value:'HKB',
            label:'汉口银行'
        },
        {
            value:'WZCB',
            label:'温州银行'
        },
        {
            value:'QDCCB',
            label:'青岛银行'
        },
        {
            value:'TZCB',
            label:'台州银行'
        },
        {
            value:'JXBANK',
            label:'嘉兴银行'
        },
        {
            value:'CSRCB',
            label:'常熟农村商业银行'
        },
        {
            value:'NHB',
            label:'南海农村信用联社'
        },
        {
            value:'CZRCB',
            label:'常州农村信用联社'
        },
        {
            value:'H3CB',
            label:'内蒙古银行'
        },
        {
            value:'SXCB',
            label:'绍兴银行'
        },
        {
            value:'SDEB',
            label:'顺德农商银行'
        },
        {
            value:'WJRCB',
            label:'吴江农商银行'
        },
        {
            value:'ZBCB',
            label:'齐商银行'
        },
        {
            value:'GYCB',
            label:'贵阳市商业银行'
        },
        {
            value:'ZYCBANK',
            label:'遵义市商业银行'
        },
        {
            value:'HZCCB',
            label:'湖州市商业银行'
        },
        {
            value:'DAQINGB',
            label:'龙江银行'
        },
        {
            value:'JINCHB',
            label:'晋城银行JCBANK'
        },
        {
            value:'ZJTLCB',
            label:'浙江泰隆商业银行'
        },
        {
            value:'GDRCC',
            label:'广东省农村信用社联合社'
        },
        {
            value:'DRCBCL',
            label:'东莞农村商业银行'
        },
        {
            value:'MTBANK',
            label:'浙江民泰商业银行'
        },
        {
            value:'GCB',
            label:'广州银行'
        },
        {
            value:'LYCB',
            label:'辽阳市商业银行'
        },
        {
            value:'JSRCU',
            label:'江苏省农村信用联合社'
        },
        {
            value:'LANGFB',
            label:'廊坊银行'
        },
        {
            value:'CZCB',
            label:'浙江稠州商业银行'
        },
        {
            value:'DYCB',
            label:'德阳商业银行'
        },
        {
            value:'JZBANK',
            label:'晋中市商业银行'
        },
        {
            value:'BOSZ',
            label:'苏州银行'
        },
        {
            value:'GLBANK',
            label:'桂林银行'
        },
        {
            value:'URMQCCB',
            label:'乌鲁木齐市商业银行'
        },
        {
            value:'CDRCB',
            label:'成都农商银行'
        },
        {
            value:'ZRCBANK',
            label:'张家港农村商业银行'
        },
        {
            value:'BOD',
            label:'东莞银行'
        },
        {
            value:'LSBANK',
            label:'莱商银行'
        },
        {
            value:'BJRCB',
            label:'北京农村商业银行'
        },
        {
            value:'TRCB',
            label:'天津农商银行'
        },
        {
            value:'SRBANK',
            label:'上饶银行'
        },
        {
            value:'FDB',
            label:'富滇银行'
        },
        {
            value:'CRCBANK',
            label:'重庆农村商业银行'
        },
        {
            value:'ASCB',
            label:'鞍山银行'
        },
        {
            value:'NXBANK',
            label:'宁夏银行'
        },
        {
            value:'BHB',
            label:'河北银行'
        },
        {
            value:'HRXJB',
            label:'华融湘江银行'
        },
        {
            value:'ZGCCB',
            label:'自贡市商业银行'
        },
        {
            value:'YNRCC',
            label:'云南省农村信用社'
        },
        {
            value:'JLBANK',
            label:'吉林银行'
        },
        {
            value:'DYCCB',
            label:'东营市商业银行'
        },
        {
            value:'KLB',
            label:'昆仑银行'
        },
        {
            value:'ORBANK',
            label:'鄂尔多斯银行'
        },
        {
            value:'XTB',
            label:'邢台银行'
        },
        {
            value:'JSB',
            label:'晋商银行'
        },
        {
            value:'TCCB',
            label:'天津银行'
        },
        {
            value:'BOYK',
            label:'营口银行'
        },
        {
            value:'JLRCU',
            label:'吉林农信'
        },
        {
            value:'SDRCU',
            label:'山东农信'
        },
        {
            value:'XABANK',
            label:'西安银行'
        },
        {
            value:'HBRCU',
            label:'河北省农村信用社'
        },
        {
            value:'NXRCU',
            label:'宁夏黄河农村商业银行'
        },
        {
            value:'GZRCU',
            label:'贵州省农村信用社'
        },
        {
            value:'FXCB',
            label:'阜新银行'
        },
        {
            value:'HBHSBANK',
            label:'湖北银行黄石分行'
        },
        {
            value:'ZJNX',
            label:'浙江省农村信用社联合社'
        },
        {
            value:'XXBANK',
            label:'新乡银行'
        },
        {
            value:'HBYCBANK',
            label:'湖北银行宜昌分行'
        },
        {
            value:'LSCCB',
            label:'乐山市商业银行'
        },
        {
            value:'TCRCB',
            label:'江苏太仓农村商业银行'
        },
        {
            value:'BZMD',
            label:'驻马店银行'
        },
        {
            value:'GZB',
            label:'赣州银行'
        },
        {
            value:'WRCB',
            label:'无锡农村商业银行'
        },
        {
            value:'BGB',
            label:'广西北部湾银行'
        },
        {
            value:'GRCB',
            label:'广州农商银行'
        },
        {
            value:'JRCB',
            label:'江苏江阴农村商业银行'
        },
        {
            value:'BOP',
            label:'平顶山银行'
        },
        {
            value:'TACCB',
            label:'泰安市商业银行'
        },
        {
            value:'CGNB',
            label:'南充市商业银行'
        },
        {
            value:'CCQTGB',
            label:'重庆三峡银行'
        },
        {
            value:'XLBANK',
            label:'中山小榄村镇银行'
        },
        {
            value:'HDBANK',
            label:'邯郸银行'
        },
        {
            value:'KORLABANK',
            label:'库尔勒市商业银行'
        },
        {
            value:'BOJZ',
            label:'锦州银行'
        },
        {
            value:'QLBANK',
            label:'齐鲁银行'
        },
        {
            value:'BOQH',
            label:'青海银行'
        },
        {
            value:'YQCCB',
            label:'阳泉银行'
        },
        {
            value:'SJBANK',
            label:'盛京银行'
        },
        {
            value:'FSCB',
            label:'抚顺银行'
        },
        {
            value:'ZZBANK',
            label:'郑州银行'
        },
        {
            value:'SRCB',
            label:'深圳农村商业银行'
        },
        {
            value:'BANKWF',
            label:'潍坊银行'
        },
        {
            value:'JJBANK',
            label:'九江银行'
        },
        {
            value:'JXRCU',
            label:'江西省农村信用'
        },
        {
            value:'HNRCU',
            label:'河南省农村信用'
        },
        {
            value:'GSRCU',
            label:'甘肃省农村信用'
        },
        {
            value:'SCRCU',
            label:'四川省农村信用'
        },
        {
            value:'GXRCU',
            label:'广西省农村信用'
        },
        {
            value:'SXRCCU',
            label:'陕西信合'
        },
        {
            value:'WHRCB',
            label:'武汉农村商业银行'
        },
        {
            value:'YBCCB',
            label:'宜宾市商业银行'
        },
        {
            value:'KSRB',
            label:'昆山农村商业银行'
        },
        {
            value:'SZSBK',
            label:'石嘴山银行'
        },
        {
            value:'HSBK',
            label:'衡水银行'
        },
        {
            value:'XYBANK',
            label:'信阳银行'
        },
        {
            value:'NBYZ',
            label:'鄞州银行'
        },
        {
            value:'ZJKCCB',
            label:'张家口市商业银行'
        },
        {
            value:'XCYH',
            label:'许昌银行'
        },
        {
            value:'JNBANK',
            label:'济宁银行'
        },
        {
            value:'CBKF',
            label:'开封市商业银行'
        },
        {
            value:'WHCCB',
            label:'威海市商业银行'
        },
        {
            value:'HBC',
            label:'湖北银行'
        },
        {
            value:'BOCD',
            label:'承德银行'
        },
        {
            value:'BODD',
            label:'丹东银行'
        },
        {
            value:'JHBANK',
            label:'金华银行'
        },
        {
            value:'BOCY',
            label:'朝阳银行'
        },
        {
            value:'LSBC',
            label:'临商银行'
        },
        {
            value:'BSB',
            label:'包商银行'
        },
        {
            value:'LZYH',
            label:'兰州银行'
        },
        {
            value:'BOZK',
            label:'周口银行'
        },
        {
            value:'DZBANK',
            label:'德州银行'
        },
        {
            value:'SCCB',
            label:'三门峡银行'
        },
        {
            value:'AYCB',
            label:'安阳银行'
        },
        {
            value:'ARCU',
            label:'安徽省农村信用社'
        },
        {
            value:'HURCB',
            label:'湖北省农村信用社'
        },
        {
            value:'HNRCC',
            label:'湖南省农村信用社'
        },
        {
            value:'NYNB',
            label:'广东南粤银行'
        },
        {
            value:'LYBANK',
            label:'洛阳银行'
        },
        {
            value:'NHQS',
            label:'农信银清算中心'
        },
        {
            value:'CBBQS',
            label:'城市商业银行资金清算中心'
        }
    ],

    //举报类型
    reportData:[
        // 虚假交易
        {
            bigId:1,
            name:'虚假交易',
            children: [
              { childId: 1, val: "利用信用积分规则" },
              { childId: 2, val: "进行恶意刷单获取相关利益" },
            ]
        },
        {
          bigId: 2,
          name: "滥发信息",
          children: [
            { childId: 1, val: "黄图" },
            { childId: 2, val: "标题滥用关键字" },
            { childId: 3, val: "类目错放" },
            { childId: 4, val: "属性错放" },
          ]
        },
        {
          bigId: 3,
          name: "出售违禁品 ",
          children: [
            { childId: 1, val: "虚拟类" },
            { childId: 2, val: "非法服务" },
            { childId: 3, val: "非法票证" },
            { childId: 4, val: "特许经营商品类" },
            { childId: 5, val: "未经允许违反国家行政法规或不适合交易的商品" },
            { childId: 6, val: "其他" },
          ]
        },
        {
          bigId: 4,
          name: "商品信息有误",
          children: [
            { childId: 1, val: "产品名称错误" },
            { childId: 2, val: "图片与实物严重不符" },
            { childId: 3, val: "商品属性错误" },
          ]
        },
        {
          bigId: 5,
          name: "虚假宣传",
          children: [
            { childId: 1, val: "绝对化用语" },
            { childId: 2, val: "虚假/夸大宣传" },
            { childId: 3, val: "使用/宣传驰名商标" },
            { childId: 4, val: "对比贬低其他商品" },
            { childId: 5, val: "专利未备注专利号" },
            { childId: 6, val: "其他" }
          ]
        },
        {
          bigId: 6,
          name: "政治有害类",
          children: [
            { childId: 1, val: "借国家领导人姓名和肖像经营" },
            { childId: 2, val: "政治敏感类" },
            { childId: 3, val: "民族（种族）敏感类" },
            { childId: 4, val: "宗教敏感类" },
            { childId: 3, val: "宣扬邪教和封建迷信类" },
            { childId: 4, val: "其他" }
          ]
        },
        {
          bigId: 100,
          name: "其他",
          children: []
        },
      ],
      sellOtherType:[
        {
            value: 'GSJY',
            label: '公司',
            children: [{ 
                value: '1',
                label: '公司注册'
            },{ 
                value: '2',
                label: '工商变更'
            },{ 
              value: '3',
              label: '求购公司'
          }]
        },
        {
            value: 'SB',
            label: '商标',
            children: [{ 
                value: '1',
                label: '商标申请'
            },{ 
                value: '2',
                label: '商标变更'
            },{ 
              value: '3',
              label: '求购商标'
          }]
        },
        {
            value: 'BQ',
            label: '版权',
            children: [{ 
                value: '1',
                label: '版权申请'
            },{ 
                value: '2',
                label: '版权变更'
            },{ 
              value: '3',
              label: '求购版权'
            }]
        },
        {
            value: 'ZL',
            label: '专利',
            children: [{ 
                value: '1',
                label: '专利申请'
            },{ 
                value: '2',
                label: '专利变更'
            },{ 
              value: '3',
              label: '求购专利'
            }]
        },
        {
            value: 'XMT',
            label: '新媒体',
            children: [{ 
                value: '1',
                label: '新媒体运营'
            },{ 
              value: '2',
              label: '求购新媒体'
            }]
        },
        {
            value: 'WD',
            label: '网店',
            children: [{ 
                value: '1',
                label: '网店申请'
            },{ 
                value: '2',
                label: '网店运营'
            },{ 
              value: '3',
              label: '求购网店'
            }]
        },
        {
            value: 'WZ',
            label: '网站',
            children: [{ 
                value: '1',
                label: '网站设计'
            },{ 
                value: '2',
                label: '网站运营'
            },{ 
              value: '3',
              label: '求购网站'
            }]
        },
      ]
  },
  mutations:{
    SET_URl:(state,url)=>{
      state.domainUrl = url + '/'
      state.uploadUrl = url + '/jbbcs/file/uploadOpenImg.do'
      state.showFile = url + '/showFile/'
      state.uploadUrlToken = url + '/jbbcs/file/uploadImg.do'
      state.showFileToken = url + '/jbbcs/file/getUploadFile/'
    },
  }
}
export default publicData



// WEBPACK FOOTER //
// ./src/store/components/publicData.js